import { ValueStub } from 'constants/data';

import { SlaDurationType, SlaDurationUnitLabel } from './SlaGroupInfoModal.constants';
import { eligibleRowStyles } from './SlaGroupInfoModal.styles';

export const getEligibleRowStyles = ({ isEligibleForSignOff }) =>
  isEligibleForSignOff ? eligibleRowStyles : null;

export const buildSlaDurationLabel = ({ slaDuration }) => {
  if (!slaDuration) {
    return ValueStub.ALTERNATE;
  }

  const unit =
    slaDuration.type === SlaDurationType.REGULAR_HOURS
      ? SlaDurationUnitLabel.HOURS
      : SlaDurationUnitLabel.DAYS;

  return `${slaDuration.duration} ${unit}`;
};
